import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../../utils/auth';
import { canManageUsers } from '../../utils/role';

/** 仅超级管理员、管理员可访问用户管理页 */
class RequireUserManager extends React.Component {
    render() {
        const { children } = this.props;
        if (!isAuthenticated()) {
            return <Navigate to="/login" replace />;
        }
        if (!canManageUsers(getUser())) {
            return <Navigate to="/admin/videos" replace />;
        }
        return children;
    }
}

export default RequireUserManager;
